import { mediacoreApi } from '@apis/mediacoreApi'
import { deleteByIdMutation, getAllByClientIdQuery } from '@apis/mediacoreQueries'
import { HTLObjective } from '@types'

const marketingObjectivesEndpointUrl = 'marketing/objetivos'

const marketingObjectivesApi = mediacoreApi.injectEndpoints({
  endpoints: (builder) => ({
    getMarketingObjectives: builder.query<HTLObjective[], { clientId: number }>({
      query: getAllByClientIdQuery(marketingObjectivesEndpointUrl),
      providesTags: ['MarketingObjective'],
    }),
    createMarketingObjective: builder.mutation<HTLObjective, { data: Partial<HTLObjective> }>({
      query: ({ data }) => ({
        url: `${marketingObjectivesEndpointUrl}/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['MarketingObjective'],
    }),
    updateMarketingObjective: builder.mutation<HTLObjective, { id: number; data: Partial<HTLObjective> }>({
      query: ({ id, data }) => ({
        url: `${marketingObjectivesEndpointUrl}/${id}/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['MarketingObjective'],
    }),
    deleteMarketingObjective: builder.mutation<void, { id: number }>({
      query: deleteByIdMutation(marketingObjectivesEndpointUrl),
      invalidatesTags: ['MarketingObjective'],
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetMarketingObjectivesQuery,
  useLazyGetMarketingObjectivesQuery,
  useCreateMarketingObjectiveMutation,
  useUpdateMarketingObjectiveMutation,
  useDeleteMarketingObjectiveMutation,
} = marketingObjectivesApi
